import React , {  useState , useEffect } from 'react'; 
 
import storage from '../factory/StorageFactory.js';
import config from '../appconfig/config.json';
import FormContainer from '../components/FormContainer.jsx';


const InvalidOTP = (props) => {

    const [isFirstTime,setIsFirstTime] = useState(true);

    useEffect(() => {
     
        if(props.location.state !== undefined) {
            setIsFirstTime(props.location.state.isFU);
        }
        clearData();
     }, []);

    const handleOnClick = () =>{
        window.location.href = config.link.Cancle;
    }

    const displayErrMsg = () => {
        let errMsg = ''
        if(isFirstTime) {
            errMsg = 'Your application is unsuccessful due to maximum number of OTP attempts. Do reapply.';
        }
        else {
            errMsg = 'Your application is unsuccessful due to maximum number of OTP attempts. Do  resume your application via the email link. ';
        }
        
        return errMsg;
    }

    const clearData =()=> {
        if(storage.getStateId() !== null){
            storage.clearAll();
        }
    }

    return(
        <div>
        <FormContainer>
        <div className="row around-xs elementVisible">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <legend id={'ftitle'} style={{textAlign:'center',paddingTop:'20px'}}>{'Oops!'}</legend>
            </div>
        </div>
        <div style={{paddingTop: "10px"}}><hr className="yellowPanelLine" /></div>
        <div className="row around-xs inputPair elementVisible">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div id={'lmsg2'} style={{textAlign:'center',fontSize:'1.3em',fontWeight:'400',paddingTop:'20px'}}>{displayErrMsg()}</div>
            </div>
        </div>

        <div className="row around-xs inputPair elementVisible">
        <div  className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div className="text-center" style={{padding: "30px"}}>
                <div>
                <button className="k-button btn btn-success" onClick={handleOnClick}>Get in touch</button>
                </div>
            </div>
        </div>                          
        </div> 
        </FormContainer>
       
        </div>
    )
}

export default InvalidOTP;